import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ConsumerResponseService } from '../../../consumer/application/consumer-response.service';
import { AbstractFetchApplicationService, FetchPaginatedApplicationsService } from './abstract-fetch-application';

@Injectable({
  providedIn: 'root'
})
export class FetchApplicationsFactoryService {
  constructor(private readonly httpClient: HttpClient, private readonly response: ConsumerResponseService) {}

  getService(): AbstractFetchApplicationService {
    const service: AbstractFetchApplicationService = new FetchPaginatedApplicationsService(
      this.httpClient,
      this.response
    );

    return service;
  }
}
